import { SxProps } from '@mui/material';

import usePlanHandler from '@webclient/components/plans/hooks/usePlanHandler';
import StyledChip from '@webclient/components/plans/kinds/credit-pack/styles';
import Card from '@webclient/components/upgrade-modal/components/card';

import { useTranslate } from '@tolgee/react';

type Props = {
  sx?: SxProps;
};

export default function CreditPack({ sx }: Props) {
  const { t } = useTranslate();
  const { isPending, handleRedirectUserToRequiredPlan } = usePlanHandler();

  return (
    <Card
      title={t('layout.upgrade.plans.creditPack.title', '20,000 Credit Pack')}
      subtitle={t(
        'layout.upgrade.plans.creditPack.subtitle',
        'Start Today and Top Up Anytime',
      )}
      sx={sx}
      priceInfo={{
        priceLine: t(
          'layout.upgrade.plans.creditPack.priceInfo.priceLine',
          '29.95',
        ),
        cycle: t(
          'layout.upgrade.plans.creditPack.priceInfo.creditLine.segment1',
          'Pack of',
        ),
        creditLine: t(
          'layout.upgrade.plans.creditPack.priceInfo.creditLine.segment2',
          '20,000 Credits',
        ),
      }}
      keyFeatures={[
        t(
          'layout.upgrade.plans.creditPack.keyFeatures.0',
          'Pay as you go, no commitment',
        ),
        t(
          'layout.upgrade.plans.creditPack.keyFeatures.1',
          'Collaborate with family, friends or small groups',
        ),
        t(
          'layout.upgrade.plans.creditPack.keyFeatures.2',
          'Credits never expire',
        ),
      ]}
      boldFeature={t(
        'layout.upgrade.plans.creditPack.boldFeature',
        '20,000 Credits top up ≈',
      )}
      badges={[
        t('layout.upgrade.plans.creditPack.badges.0', '2,000 Docs'),
        t('layout.upgrade.plans.creditPack.badges.1', '2,000 Searches'),
      ]}
      button={{
        onClick: handleRedirectUserToRequiredPlan('creditPack'),
        text: t('layout.upgrade.plans.creditPack.button', 'Add Credits'),
        isLoading: isPending,
      }}
    >
      <StyledChip
        label="One Off"
        variant="outlined"
        size="small"
      />
    </Card>
  );
}
